import { TYPE_THEMATIQUE } from '../constants';

export const FETCH_EXAM_REJECTED = 'FETCH_EXAM_REJECTED';

export const FETCH_EXAM_PENDING = 'FETCH_EXAM_PENDING';
function fetchExamPending() {
  return {
    type: FETCH_EXAM_PENDING,
    payload: null
  }
}

export const FETCH_EXAM_FULFILLED = 'FETCH_EXAM_FULFILLED';
function fetchExamFulfilled(exam) {
  return {
    type: FETCH_EXAM_FULFILLED,
    payload: exam
  }
}

export function fetchExam(elementRoot) {
  return dispatch => {
    // Inform that the API call is starting
    dispatch(fetchExamPending());
    const dev = process.env.NODE_ENV === 'development';

    const apiUrl = dev ? process.env.REACT_APP_API_URL : elementRoot.dataset.apiurl;
    const urlParams = new URLSearchParams({
      mode: dev ? process.env.REACT_APP_MODE : elementRoot.dataset.mode,
      type: dev ? process.env.REACT_APP_TYPE : elementRoot.dataset.type,
      categorie: dev ? process.env.REACT_APP_CATEGORY_ID : elementRoot.dataset.idcategorie,
      id_candidat: dev ? process.env.REACT_APP_USER_ID : elementRoot.dataset.idcandidat,
      id_questionnaire: dev ? process.env.REACT_APP_TEST_ID : elementRoot.dataset.idquestionnaire
    });

    return fetch(apiUrl + '?' + urlParams.toString())
      .then(response => response.json(), error => console.log(error))
      .then(json => {
        json.max = dev ? process.env.REACT_APP_MAX : elementRoot.dataset.max;
        dispatch(fetchExamFulfilled(json));
        document.addEventListener('blur', () => dispatch(startPause()), false);
      })
      .catch(err => console.log(err))
  }
}

export function startAudio(id, sound) {
  return (dispatch, getState) => {
    const {api, displayAudio} = getState().exam;

    // If audio is not available, start the timer straight away
    if (!displayAudio) {
      const timer = setInterval(() => dispatch(decrementTimer()), 1000);
      dispatch(startTimer(timer));
    } else {
      dispatch(audioStop());
      const audio = new Audio(api.audioUrl + '/' + id + '.mp3');
      audio.muted = !sound;
      audio.play()
        .then(() => {
          dispatch(audioStart(audio));
          audio.addEventListener('ended', () => {
            const timer = setInterval(() => dispatch(decrementTimer()), 1000);
            dispatch(startTimer(timer));
          });
        })
        .catch(err => console.log(err))
      ;
    }
  }
}

export function togglePause() {
  return (dispatch, getState) => {
    return getState().exam.pause ? dispatch(stopPause()) : dispatch(startPause());
  }
}

export function startPause() {
  return (dispatch, getState) => {
    const {pause, audio, timeLeftTimer, showSplashScreen} = getState().exam;
    // Check if pause already active or on splashscreen
    if (!pause && !showSplashScreen) {
      // Remove timer
      if (timeLeftTimer != null) {
        clearInterval(timeLeftTimer);
      }
      // Pause audio if started
      if (audio) {
        audio.pause();
      }
      dispatch(togglePauseFulfilled());
    }
  }
}

export function stopPause() {
  return (dispatch, getState) => {
    const {pause, audio, timeLeftTimer} = getState().exam;
    // Check if pause already active
    if (pause) {
      // Check if timer started
      if (timeLeftTimer != null) {
        // Restart timer
        const timer = setInterval(() => dispatch(decrementTimer()), 1000);
        dispatch(startTimer(timer));
        dispatch(togglePauseFulfilled());
      } else if (audio) {
        // Restart audio
        audio.play()
          .then(() => dispatch(togglePauseFulfilled()))
          .catch(err => dispatch(togglePauseRejected(err)))
      }
    }
  }
}

export function checkQuestionIsValid(question, answers) {
  let result = {
    valid: true,
    values: [],
    missing: [],
    wrong: []
  };

  if (typeof answers === 'undefined') {
    result.valid = false;
    return result;
  }

  // Loop over question subquestions
  for (let i = 0; i < question.questions.length; i++) {
    let q = question.questions[i];
    // Loop over question answers
    for (let j = 0; j < q.reponses.length; j++) {
      let r = q.reponses[j];
      if (r.correcte && !answers.includes(r.lettre)) {
        result.missing.push(r.lettre);
        result.values.push(r.lettre);
        result.valid = false;
      } else if (!r.correcte && answers.includes(r.lettre)) {
        result.wrong.push(r.lettre);
        result.values.push(r.lettre);
        result.valid = false;
      }
    }
  }

  return result;
}

export function saveExam() {
  return (dispatch, getState) => {
    dispatch(saveExamPending());

    const {questions, choices, api, testId, testNumber, userId, mode, type, categoryId, categories} = getState().exam;

    let nombreErreur = 0;
    let questionsErreur = [];
    let userReponses = [];
    let catErreur = [];
    let catOk = [];
    let subcatErreur = [];
    let subcatOk = [];
    let serie = [];
    for(let i = 0; i < questions.length; i++) {
      let question = questions[i];
      let answers = choices[i].values;
      let checkQuestion = checkQuestionIsValid(question, answers);
      serie.push(question.id);
      if (!checkQuestion.valid) {
        nombreErreur++;
        questionsErreur.push(question.id);
        catErreur.push(question.cat);
        subcatErreur.push(question.subcat);
      } else {
        catOk.push(question.cat);
        subcatOk.push(question.subcat);
      }
      userReponses.push(Array.isArray(answers) && answers.length > 0 ? answers.join(';') : 0);
    }

    let formData = new FormData();
    formData.append('identifiant', userId);
    formData.append('id_questionnaire', testId);
    formData.append('id_candidat', testNumber);
    formData.append('mode', mode);
    formData.append('type', type);
    formData.append('categorie', categoryId);
    formData.append('erreurs_nbre', nombreErreur);
    formData.append('erreurs_questions', questionsErreur.join(','));
    formData.append('user_reponses', userReponses.join(','));
    formData.append('cat_erreur', catErreur.join(','));
    formData.append('cat_ok', catOk.join(','));
    formData.append('subcat_erreur', subcatErreur.join(','));
    formData.append('subcat_ok', subcatOk.join(','));
    formData.append('serie', serie.join(','));
    formData.append('categories', JSON.stringify(categories.filter(cat => cat.total > 0))); // Get score per categories where total > 0

    return fetch(api.postExamUrl, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(json => dispatch(saveExamFulfilled(json)))
      .catch(err => dispatch(saveExamRejected(err)))
  }
}

export const SAVE_EXAM_REJECTED = 'SAVE_EXAM_REJECTED';
function saveExamRejected(err) {
  return {
    type: SAVE_EXAM_REJECTED,
    payload: err
  }
}

export const SAVE_EXAM_PENDING = 'SAVE_EXAM_PENDING';
function saveExamPending() {
  return {
    type: SAVE_EXAM_PENDING,
    payload: null
  }
}

export const SAVE_EXAM_FULFILLED = 'SAVE_EXAM_FULFILLED';
function saveExamFulfilled(exam) {
  return {
    type: SAVE_EXAM_FULFILLED,
    payload: exam
  }
}

export function validateChoices() {
  return (dispatch, getState) => {
    const {currentQuestion, questions, type, showSolution, timeLeftTimer} = getState().exam;

    if (type === TYPE_THEMATIQUE && !showSolution) {
      // Show solutions and stop timer
      dispatch(toggleSolution());
      dispatch(toggleComments());
      clearInterval(timeLeftTimer);
    } else {
      dispatch(confirmSelection());
      if (currentQuestion + 1 === questions.length) {
        dispatch(saveExam());
      }
      dispatch(nextQuestion());
    }
  };
}

export const START_TIMER = 'START_TIMER';
export function startTimer(timer) {
  return {
    type: START_TIMER,
    payload: timer
  }
}

export const DECREMENT_TIMER = 'DECREMENT_TIMER';
export function decrementTimer() {
  return {
    type: DECREMENT_TIMER
  }
}

export const GOTO_QUESTION = 'GOTO_QUESTION';
export function gotoQuestion(index) {
  return {
    type: GOTO_QUESTION,
    payload: index
  }
}

export const NEXT_QUESTION = 'NEXT_QUESTION';
export function nextQuestion() {
  return {
    type: NEXT_QUESTION
  }
}

export const PREV_QUESTION = 'PREV_QUESTION';
export function prevQuestion() {
  return {
    type: PREV_QUESTION
  }
}

export const SELECT_ANSWER = 'SELECT_ANSWER';
export function selectAnswer(choice) {
  return {
    type: SELECT_ANSWER,
    payload: choice
  }
}

export const DESELECT_ANSWER = 'DESELECT_ANSWER';
export function deselectAnswer(choice) {
  return {
    type: DESELECT_ANSWER,
    payload: choice
  }
}

export const CLEAR_SELECTION = 'CLEAR_SELECTION';
export function clearSelection() {
  return {
    type: CLEAR_SELECTION
  }
}

export const CONFIRM_SELECTION = 'CONFIRM_SELECTION';
export function confirmSelection() {
  return {
    type: CONFIRM_SELECTION
  }
}

export const TOGGLE_SPLASHSCREEN = 'TOGGLE_SPLASHSCREEN';
export function toggleSplashScreen() {
  return {
    type: TOGGLE_SPLASHSCREEN
  }
}

export const TOGGLE_COMMENTS = 'TOGGLE_COMMENTS';
export function toggleComments() {
  return {
    type: TOGGLE_COMMENTS
  }
}

export const TOGGLE_SOLUTION = 'TOGGLE_SOLUTION';
export function toggleSolution() {
  return {
    type: TOGGLE_SOLUTION
  }
}

export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
export function toggleFullscreen() {
  return {
    type: TOGGLE_FULLSCREEN
  }
}

export const TOGGLE_IMAGE_FULLSCREEN = 'TOGGLE_IMAGE_FULLSCREEN';
export function toggleImageFullscreen() {
  return {
    type: TOGGLE_IMAGE_FULLSCREEN
  }
}

export const TOGGLE_SOUND = 'TOGGLE_SOUND';
export function toggleSound() {
  return {
    type: TOGGLE_SOUND
  }
}

export const TOGGLE_PAUSE_PENDING = 'TOGGLE_PAUSE_PENDING';
export function togglePausePending() {
  return {
    type: TOGGLE_PAUSE_PENDING
  }
}

export const TOGGLE_PAUSE_REJECTED = 'TOGGLE_PAUSE_REJECTED';
export function togglePauseRejected(err) {
  return {
    type: TOGGLE_PAUSE_REJECTED,
    payload: err
  }
}

export const TOGGLE_PAUSE_FULFILLED = 'TOGGLE_PAUSE_FULFILLED';
export function togglePauseFulfilled() {
  return {
    type: TOGGLE_PAUSE_FULFILLED
  }
}

export const AUDIO_START = 'AUDIO_START';
export function audioStart(audio) {
  return {
    type: AUDIO_START,
    payload: audio
  }
}

export const AUDIO_STOP = 'AUDIO_STOP';
export function audioStop() {
  return {
    type: AUDIO_STOP
  }
}

export const DISPLAY_AUDIO = 'DISPLAY_AUDIO';
export function displayAudio(elementRoot) {
  return {
    type: DISPLAY_AUDIO,
    payload: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DISPLAY_AUDIO : elementRoot.dataset.son
  }
}
